import { newId } from './sectionDefs.js'

// Example content for the built in sections, so a user can see how a full resume looks in a
// template. Made fresh each time (new entry ids). It leaves the look settings, the picture and
// the user's own custom sections alone.
export const SAMPLE_SECTIONS = ['basics', 'summary', 'experience', 'education', 'skills', 'projects', 'certifications', 'languages']

export function sampleSections() {
  return {
    basics: {
      full_name: 'Alex Morgan',
      headline: 'Senior Software Engineer',
      email: 'alex.morgan@example.com',
      phone: '+1 555 010 2030',
      location: 'San Francisco, CA',
      website: 'https://alexmorgan.dev',
      linkedin: 'https://linkedin.com/in/alexmorgan',
      github: 'https://github.com/alexmorgan',
      links: [],
    },
    summary: 'Senior software engineer with 9 years of experience building reliable, high traffic web products. '
      + 'Leads small teams, turns unclear problems into simple designs, and ships steadily. '
      + 'Strongest in Ruby and TypeScript backends, performance work and mentoring engineers.',
    experience: [
      {
        id: newId(), title: 'Senior Software Engineer', company: 'Northwind Labs', location: 'San Francisco, CA',
        start_date: 'Mar 2021', end_date: '', current: true,
        description: 'Tech lead for the payments platform, a team of six engineers serving 2M monthly users.',
        bullets: [
          'Cut checkout latency by 42% by redesigning the order pipeline and adding read replicas.',
          'Led the migration from a monolith to four services with zero downtime and no lost orders.',
          'Introduced contract tests and a staged rollout process, reducing production incidents by 60%.',
          'Mentored five engineers, two of whom were promoted within 18 months.',
        ],
      },
      {
        id: newId(), title: 'Software Engineer', company: 'Brightpath', location: 'Remote',
        start_date: 'Jun 2018', end_date: 'Feb 2021', current: false,
        description: 'Built the customer analytics product from the first prototype to 400 paying teams.',
        bullets: [
          'Designed the event ingestion pipeline handling 50M events a day on a small infrastructure budget.',
          'Shipped a self serve onboarding flow that raised trial to paid conversion from 9% to 14%.',
          'Reduced the monthly cloud bill by 28% through query tuning and smarter caching.',
        ],
      },
      {
        id: newId(), title: 'Junior Developer', company: 'Studio Nine', location: 'Austin, TX',
        start_date: 'Aug 2016', end_date: 'May 2018', current: false, description: '',
        bullets: [
          'Delivered client websites and internal tools for more than 20 customers.',
          'Automated deployments, cutting release time from half a day to ten minutes.',
        ],
      },
    ],
    education: [
      {
        id: newId(), school: 'University of Texas at Austin', degree: 'BSc', field: 'Computer Science', location: 'Austin, TX',
        start_date: '2012', end_date: '2016', grade: 'GPA 3.8', description: '',
      },
    ],
    skills: [
      { id: newId(), name: 'Languages', items: ['Ruby', 'TypeScript', 'Python', 'SQL', 'Go'] },
      { id: newId(), name: 'Frameworks', items: ['Rails', 'Vue', 'React', 'Node.js'] },
      { id: newId(), name: 'Infrastructure', items: ['AWS', 'Docker', 'PostgreSQL', 'Redis', 'Terraform'] },
    ],
    projects: [
      {
        id: newId(), name: 'OpenQueue', url: 'https://github.com/alexmorgan/openqueue', tech: 'Go, Redis',
        description: 'An open source job queue with scheduling and retries.',
        bullets: ['2,400 stars on GitHub and used in production by more than 60 teams.'],
      },
      {
        id: newId(), name: 'Trailhead', url: '', tech: 'Rails, Vue',
        description: 'A side project that helps hikers plan and share routes.', bullets: [],
      },
    ],
    certifications: [
      { id: newId(), name: 'AWS Certified Solutions Architect', issuer: 'Amazon Web Services', date: 'Mar 2023', url: '' },
      { id: newId(), name: 'Professional Scrum Master I', issuer: 'Scrum.org', date: 'Nov 2021', url: '' },
    ],
    languages: [
      { id: newId(), name: 'English', level: 'Native' },
      { id: newId(), name: 'Spanish', level: 'Fluent' },
      { id: newId(), name: 'German', level: 'Basic' },
    ],
  }
}
